// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = {
    exclude: false,
  };
}.call(this));
